import axios from 'axios'

export function postRequest(url,data,bearerToken='') {
    return axios.post(url,data,
    { 
        crossdomain: true,
        headers:{
            'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
			'Authorization' : `Bearer ${bearerToken}`
        }
   })
}
export function putRequest(url,data,bearerToken='') {
	return axios.put(url,data,
	{ 
		crossdomain: true,
		headers: {
			'Access-Control-Allow-Origin' : '*',
			'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
			'Authorization' : `Bearer ${bearerToken}`
		}
	})
}

export function getRequest(url, responseType,bearerToken='') 
{
	//console.log(`getRequest bearerToken ${url}, ${bearerToken}`)
	return axios.get(url,
		{ 
			crossdomain: true,
			headers: {
				'Access-Control-Allow-Origin' : '*',
				'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
				'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1,private',				
				'Authorization' : `Bearer ${bearerToken}`
			},
			responseType: responseType != undefined ? responseType: 'json'
		})
}


// WEBPACK FOOTER //
// ./src/utils/httpRequest.js